// import type { Id } from 'flowTypes/common';
import { schema } from 'normalizr';

import { opDefSchema } from 'modules/opDefs/data/entities';

// import type { OpDef } from 'modules/opDefs/data/entities';

// import type { SupplierMaterial } from 'store/materials/entities';

export const OP_FACTORY_CLASS_NAMES = {
  CUSTOM: 'custom',
  MANUFACTURING: 'manufacturing',
  MARKETPLACE: 'marketplace',
  MILL3: 'mill3',
};

// export type Color = {
//   id: Id,
//   name: String,
// };

// export type Material = {
//   id: Id,
//   name: String,
// };

// export type ProcessMaterial = {
//   id: Id,
//   processId: Id,
//   supplierMaterial: SupplierMaterial,
// };

// type Finish = {|
//   id: number,
//   name: string,
//   explanation: string,
// |};

// export type ProcessFinish = {
//   id: Id,
//   finish: Finish,
//   cost: string,
//   addedLeadTime: number,
// };

// type OpFactoryClassName = 'marketplace' | 'manufacturing' | 'cnc';

// type OpDefTemplate = {
//   opDefId: Id,
//   position: number,
// };

// type CNCOpDefTemplate = {
//   ...$Exact<OpDefTemplate>,
//   isPerSetup: boolean,
// };

// type LegacyOpFactory = {
//   opDefId: Id,
// };

// type TemplatedOpFactory = {
//   opDefTemplates: Array<OpDefTemplate>,
// };

// type CNCOpFactory = {
//   opDefTemplates: Array<CNCOpDefTemplate>,
// };

// export type OpFactory = LegacyOpFactory | TemplatedOpFactory | CNCOpFactory;

// export type LegacyOpFactoryFields = {
//   opFactoryClassName: 'marketplace',
//   opFactory: LegacyOpFactory,
// };

// export type TemplatedOpFactoryFields = {
//   opFactoryClassName: 'manufacturing',
//   opFactory: TemplatedOpFactory,
// };

// export type CNCOpFactoryFields = {
//   opFactoryClassName: 'cnc',
//   opFactory: CNCOpFactory,
// };

// export type BaseProcess = {
//   id: Id,
//   name: string,
//   externalName: ?string,
//   yieldPct: number,
//   standardLeadTime: number,
//   public: boolean,
//   quoteItemCount?: number,
//   useGlobalMaterials: Boolean,
//   processMaterials: Array<ProcessMaterial>,
//   processFinishes: Array<ProcessFinish>,
// };

// export type Process = {
//   ...$Exact<BaseProcess>,
//   opFactoryClassName: OpFactoryClassName,
// };

// export type CreatedProcess = {
//   ...$Exact<BaseProcess>,
//   operationDefinitions: Array<OpDef>,
// };

export const materialSchema = new schema.Entity('materials');
export const finishSchema = new schema.Entity('finishes');
export const processMaterialSchema = new schema.Entity('processMaterials');
export const processFinishSchema = new schema.Entity('processFinishes', {
  finish: finishSchema,
});
export const processSchema = new schema.Entity('processes', {
  processMaterials: [processMaterialSchema],
  processFinishes: [processFinishSchema],
  operationDefinitions: [opDefSchema],
});
